﻿import { GridEditorDialog } from "@/Common/Helpers/GridEditorDialog";
import { SqlProcLookupParameterForm } from "@/ServerTypes/Data/SqlProcLookupParameterForm";
import { WidgetProps } from "@serenity-is/corelib";
import { SqlProcLookupParameter } from "@/ServerTypes/Data/SqlProcLookupParameter";
import { nsData } from "@/ServerTypes/Namespaces";

export class SqlProcLookupParameterDialog extends GridEditorDialog<SqlProcLookupParameter> {
    static override[Symbol.typeInfo] = this.registerClass(nsData);

    protected override getFormKey() { return SqlProcLookupParameterForm.formKey; }
    protected override getNameProperty() { return "Name"; }
    protected override getEntitySingular() { return "Parameter"; }

    protected form = new SqlProcLookupParameterForm(this.idPrefix);

    constructor(props?: WidgetProps<{}>) {
        super(props);
    }
}
